import { axiosInstanceForPublicAPI } from './axiosInstance';

export const downloadFileBlob = async (url: string) => {
  return axiosInstanceForPublicAPI().get(url, { responseType: 'blob' });
};
